import React from "react";
import popop_close from '../assets/images/popop_close.png'; 


function Termsandconditions({ isActive, onClose }) {
  // Merge the dynamic class with static class names
  const mainClassName = `termspopup_main pops ${isActive ? "active" : ""}`;
  const innerClassName = `termspopup_inner popsin`;

  return (

  
        <div className={mainClassName}>
          <div className={innerClassName}>
              <img className="popup_close" src={popop_close} onClick={onClose} alt="" width="43" height="43" />
              <div className="customscroll">
              <h2>ORDERS</h2>
              <ul>
                <li>This APP is for BlossomsFood ordering system, solely for our clients only.</li>
                <li>Request for an account to login. If you have an online account, please proceed to login into the system.
</li>
                <li>Orders are subjected to availability.</li>
                <li>New accounts will be reviewed. It will be activated once it is approvedi.</li>
                <li>You will receive an email confirmation of your order. After we have reviewed the order, an email notification will be send to the customer stating the order status. Customers will need to login to the system to check the order and the pricing. Upon accepting the order it will be processed. If the price quoted is not within your budget please contact or email us.
</li><li>Please note that the cut off date for ordering is on every Tuesday 3pm. Any order received after Tuesday 3pm will be subjected to availability.</li>
              </ul>
              <h2>Delivery Charges And Period</h2>
              <ul>
                <li>Delivery timing may change without notice due to peak hour traffic or heavy order days.
</li>
<li>Delivery charges may apply for small amount orders.</li>
              </ul>
              </div>
          </div>
        </div>

    );
}

export default Termsandconditions;
